const mediaItems = [
  {
    id: 1,
    title: '星际征途：新纪元',
    subtitle: '科幻动作巨制 · 4K杜比视界',
    desc: '人类文明远征深空，遭遇未知文明挑战，史诗级太空冒险震撼来袭。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20still%20with%20futuristic%20spaceship%20flying%20through%20nebula%20clouds%2C%20dramatic%20space%20battle%20scene%2C%20warm%20orange%20and%20deep%20blue%20cosmic%20lighting%2C%20epic%20wide%20angle%20cinematography%2C%20professional%20film%20color%20grading%2C%20dark%20deep%20space%20background%20with%20stars%2C%20no%20visible%20text%20or%20faces&width=800&height=450&seq=media-1-momo&orientation=landscape',
  },
  {
    id: 2,
    title: '时光旅人',
    subtitle: '温情剧情佳作 · 豆瓣8.7分',
    desc: '一个穿越时空的温暖故事，关于爱、记忆与和解的动人旅程。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20scene%20with%20golden%20sunset%20light%20pouring%20through%20window%2C%20vintage%20room%20interior%20with%20soft%20dust%20particles%20floating%20in%20light%20beam%2C%20nostalgic%20atmosphere%2C%20film%20grain%20texture%2C%20warm%20amber%20tone%2C%20emotional%20storytelling%20mood%2C%20no%20text&width=800&height=450&seq=media-2-momo&orientation=landscape',
  },
  {
    id: 3,
    title: '暗夜追踪',
    subtitle: '悬疑犯罪力作 · 暑期档热映',
    desc: '雨夜都市，一名警探与连环案件展开高智商对决，反转不断。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20scene%20with%20rainy%20city%20street%20at%20night%2C%20wet%20asphalt%20reflecting%20neon%20signs%2C%20dramatic%20noir%20lighting%20with%20deep%20shadows%2C%20mysterious%20atmosphere%2C%20professional%20film%20color%20grading%20with%20teal%20and%20warm%20highlights%2C%20suspenseful%20mood%2C%20empty%20street%2C%20no%20text%20or%20people&width=800&height=450&seq=media-3-momo&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-play-circle-line mr-1"></i>最新预告
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩预告</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">抢先观看最新上线的电影预告，发现你的下一部心头好</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div key={item.id} className="group rounded-xl bg-background-100 border border-secondary-200/50 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white text-xl group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-black/60 backdrop-blur-sm text-white text-xs font-medium">4K</span>
              </div>
              <div className="p-4">
                <p className="text-xs text-primary-600 font-medium mb-1">{item.subtitle}</p>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}